module.exports = __webpack_public_path__ + "static/img/77092H_R_02_20170815_fit.04d59a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/77092H_R_02_20170815_fit.png
// module id = ptLn
// module chunks = 0